import { createEffect, createStore } from "effector";
import api from "./api";

const $auth = createStore({
  isLogin: false,
  message: "",
  isFetching: true,
  accessFlags: { paidServices: {} },
});

export const loginFx = createEffect(async () => api.get(`auth/login`));

$auth.on(loginFx, (state) => {
  return {
    ...state,
    isFetching: true,
  };
});

$auth.on(loginFx.done, (state, { result }) => {
  return {
    ...state,
    isLogin: true,
    message: "",
    ...result.data?.data,
  };
});

$auth.on(loginFx.fail, (state, { error }) => {
  return {
    ...state,
    message: `${error.response?.data?.exception}`,
    isLogin: false,
  };
});

$auth.on(loginFx.finally, (state) => {
  return {
    ...state,
    isFetching: false,
  };
});

export default $auth;
